import { SCREEN_WIDTH_BREAKPOINT } from "constant/common_constants";
import styled from "styled-components";

export const ArtistRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  gap: 1rem;
`;

export const TextColumn = styled.div`
  width: 50%;
  font-size: 0.85rem;
  color: #000;

  @media (min-width: ${SCREEN_WIDTH_BREAKPOINT}) {
    font-size: 1rem;
  }
`;

export const ImageColumn = styled.div`
  display: flex;
  width: 50%;
`;

export const Image = styled.img`
  width: 100%;
`;

export const Link = styled.a`
  display: flex;
  width: 100%;
  color: inherit;
  text-decoration: none;
`;

export const ArrowIcon = styled.img`
  margin-left: 0.5rem;
`;

export const ArtistName = styled.span`
  display: block;
  font-weight: bold;
  margin-bottom: 0.5rem;
  color: black;
  margin-top: 0rem;
`;
